export default __webpack_public_path__ + "static/media/about-page-img.83f981ea.jpg";